/**
 * Component: Customers navigation
 * -----------------------------------------------------------------------------
 * Adds log out notification to customers navigation.
 *
 */
import timings from '~/config/timings'
import { onWindowKeyReady } from '~/helpers/general'

/**
 * DOM selectors.
 */
const selectors = {
  logout: '[js-customers-navigation="logout"]',
  preferences: '[js-customers-navigation="preferences"]',
}

/**
 * Create a new customers navigation object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    logout: document.querySelector(selectors.logout),
    preferences: document.querySelector(selectors.preferences),
  }

  /**
   * Initialise component.
   */
  function init() {
    if (!nodeSelectors.logout) {
      return
    }

    setEventListeners()

    /**
     * `window.hasConsentUrl` is assigned `true` in Bloomreach's Tag Manager
     * after `window.dataLayer` is updated with the customer consent URL.
     */
    onWindowKeyReady('hasConsentUrl').then(() => setPreferencesUrl())
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    if (!cnvs.settings.notifications.logout) {
      return
    }

    nodeSelectors.logout.addEventListener('click', async(event) => {
      event.preventDefault()

      cnvs.EventBus.emit('cnvs:set-notification', {
        displayUrl: cnvs.routes.root,
        text: cnvs.strings.customers.notifications.logout,
        timeout: timings.message,
        type: 'success',
      })

      await cnvs.Sleep(0)
      location.href = cnvs.routes.account.logout
    })
  }

  /**
   * Set customer preferences URL from Bloomreach.
   */
  function setPreferencesUrl() {
    const preferences = window.dataLayer.find((item) => item?.customerConsentUrl)

    if (!preferences) {
      return
    }

    nodeSelectors.preferences.href = preferences.customerConsentUrl
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
